// ═══════════════════════════════════════════════════════════════
//  siteData.js  —  CruxBytes — Single source of truth
// ═══════════════════════════════════════════════════════════════

export const SITE = {
  name:     'CruxBytes',
  fullName: 'CruxBytes Consultancy Services',
  metaTagPostText:' | CruxBytes Consultancy Services',
  tagline:  'Delivering Technology. Enabling Businesses.',
  desc:     'CruxBytes is an AI driven software development company headquartered in Thane, Mumbai (MMR), India, serving businesses across the globe, for startups as well as established enterprises.',
  email:    'sales@cruxbytes.com',  
  address:  `506, Sunrise Business Park
      Plot B-68, Road No. 16
      Wagle Estate, Thane (W) - 400 604
      Maharashtra, India`,
  founded:  '2010',
  gstNo:    '27ABRPH7944Q1ZL',
  logo:     '/assets/images/cruxbytes-logo.svg',
  logoDark: '/assets/images/cruxbytes-logo-dark.svg',
  onlyLogo: '/assets/images/cruxbytes-icon.png',
  soleProprietor:'Mr. Vikiraj Hinger',
  social: {
    linkedin: 'https://www.linkedin.com/company/cruxbytes-consultancy-services',
    twitter:  '#',   // ← placeholder, swap with your real X/Twitter URL later
    email:  'sales{at}cruxbytes{dot}com',   
  },
  mail_bcc:'contact@cruxbytes.com',
    url:      'https://www.cruxbytes.com',
  ogImage:  '/assets/images/og-default.jpg',
}

// ─── App Screenshots Marquee (Home page, above "What We Do") ────
// ★ Replace `image` with your real app/product screenshots (portrait,
//   ~9:19 aspect ratio works best for the phone-mockup frame).
export const SHOWCASE = [
  { id: 1, image: '/assets/images/banner_merit.png', label: '' },
  { id: 2, image: '/assets/images/banner-word-cloud.jpg',    label: '' },
  { id: 3, image: '/assets/images/banner-simplify.jpg', label: '' },
  { id: 4, image: '/assets/images/banner_websites.png',    label: '' },  
  { id: 5, image: '/assets/images/banner_ujala.png', label: '' },
  { id: 6, image: '/assets/images/banner_praapti.png', label: '' },
  
  // { id: 6, image: '/banner/cxb2.png',    label: '' },
]

export const ROUTES = {
  // Home
  HOME: '/',

  // Consulting
 
  SOFTWARE_CONSULTING: '/consulting/software-consulting',
  AI_STRATEGY_CONSULTING: '/consulting/ai-strategy-consulting',
  CLOUD_CONSULTING: '/technology-consulting/cloud-consulting',
  CTO_AS_A_SERVICE: '/staff-augmentation/cto-as-a-service',
  //LEGACY_SYSTEM_MODERNIZATION: '/technology-consulting/legacy-system-modernization',
  SECURITY_COMPLIANCE_ADVISORY: '/consulting/security-compliance-advisory',

  // IT Services
  //IT_SERVICES: '/services',

  // Design & Product
  UI_UX_DESIGN: '/design-product/ui-ux',
  PRODUCT_EXPERIENCE_DESIGN: '/design-product/product-experience-design',

  // Software Development
  ON_DEMAND_APP_DEVELOPMENT: '/software-development/on-demand-app-development',
  SAAS_PLATFORM_DEVELOPMENT: '/software-development/saas-product-development',
  EGOVERNANCE: '/software-development/egovernance-dashboards',
  APPLICATION_MODERNIZATION: '/software-development/application-modernization',

  // Software Testing & QA
  FUNCTIONAL_TESTING: '/software-testing-qa/functional-testing',
  PERFORMANCE_TESTING: '/software-testing-qa/performance-testing',
  API_TESTING: '/software-testing-qa/api-testing',

  // Maintenance & Support
  AMC: '/managed-it-services/software-maintenance-support-amc',
  DEVOPS: '/managed-it-services/devops-infrastructure-management',
  CLOUD_SERVICES: '/managed-it-services/cloud-services-management',
  DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT:
    '/managed-it-services/domain-email-hosting-services',

  // Staff Augmentation
  STAFF_AUGMENTATION: '/staff-augmentation/hire-dedicated-developers',

  // AI/ML Solutions
  
  AI_INTEGRATION_APPLICATION_DEVELOPMENT: '/ai-ml-development/ai-integration-application-development',
  GENAI_INTELLIGENT_ASSISTANTS: '/ai-ml-development/genai-intelligent-assistants',
  AI_WORKFLOW_AUTOMATION_AGENTS: '/ai-ml-development/ai-workflow-automation-agents',
  AI_MACHINE_LEARNING_SOLUTIONS: '/ai-ml-development/ai-machine-learning-solutions',
  AI_USECASES_BUSINESS_APPLICATIION: '/ai-ml-development/ai-usecases-business-applications',

  // Know Us
  KNOW_US: '/know-us',
  OUR_LEGACY: '/about-us',
  LEADERSHIP: '/leadership',
  CAREERS: '/careers',
  BE_A_PARTNER: '/partnerships',

  
  
  OUR_EXPERTISE: '/portfolio/our-expertise',
  CLIENT_CORNER: '/portfolio/our-client',
  OUR_WORK: '/portfolio/our-work',
POLICIES: '/policies',
TERMS_OF_USE: '/policies#terms-of-use',
  PRIVACY_POLICY: '/policies#privacy-policy',
  DISCLAIMER: '/policies#disclaimer',
APPLY_FOR_JOB: '/apply-for-job',
SALES_ENQUIRY: '/talk-to-sales',
SITEMAP: '/sitemap',
};



export const NAV_LINKS = [
   { label: 'Home', href: ROUTES.HOME },
  {
    label: 'Consulting & Design',
    href: "",
    megaColumns: 2,
     drillGroups: true, //for show mobile hierarchy
    pbExtra: 0,
    children: [
      {
        heading: "Consulting",
        icon:'',// 'ShieldCheck',
        items: [
          { label: 'Software Consulting', href: ROUTES.SOFTWARE_CONSULTING, icon: 'assets/images/icon/software-consulting.png', pageDesc: 'Transforming ideas into scalable web, mobile, and cloud solutions.' ,metaDesc:'Make smarter technology decisions with software consulting from CruxBytes. Get guidance on software architecture, technology strategy and modernization.'},
          { label: 'AI Strategy Consulting', href: ROUTES.AI_STRATEGY_CONSULTING, icon: 'assets/images/icon/ai-strategy.png', pageDesc: 'Navigate your AI journey with expert strategy, planning, and technology guidance.' ,metaDesc:'Turn AI opportunities into business value with AI strategy consulting. Assess readiness, prioritize use cases and plan practical AI solutions.' },
       
          // { label: 'Cloud Consulting', href: ROUTES.CLOUD_CONSULTING, icon: 'assets/images/icon/cloud-consulting.png', desc: 'Advisory services for scalable and future-ready cloud solutions.' },
          { label: 'Security & Compliance Advisory', href: ROUTES.SECURITY_COMPLIANCE_ADVISORY, icon: 'assets/images/icon/security.png', pageDesc: 'Expert security and compliance consulting tailored to your business needs.',metaDesc:'Strengthen web application security and compliance readiness with CruxBytes. Get advisory support for GIGW, STQC, WCAG, DPDP and web application security.' },
         
        ],
      },
      // {
      //   heading: "",
      //   icon: 'ShieldCheck',
      //   items: [
      //     { label: 'Legacy System Modernization', href: ROUTES.LEGACY_SYSTEM_MODERNIZATION, icon: 'assets/images/icon/legacy-system.png', desc: 'Modernize existing software to meet todays business and technology demands' },
      //   ],
      // },
       {
        heading: "Design & Product",
        icon: 'ShieldCheck',
        items: [
          { label: 'UI/UX Design', href: ROUTES.UI_UX_DESIGN, icon: 'assets/images/icon/ui-ux.png', pageDesc: 'Craft engaging, accessible interfaces that simplify experiences and improve conversions.' ,metaDesc:'Create intuitive digital experiences with UI/UX design services from CruxBytes, including user research, wireframes, prototypes and responsive interface design.'},         
          { label: 'Product Experience Design', href: ROUTES.PRODUCT_EXPERIENCE_DESIGN, icon: 'assets/images/icon/product-experience.png', highlight: true, pageDesc: 'Shape user-centric product journeys that deliver value at every touchpoint.' ,metaDesc:'Design useful, engaging digital products with CruxBytes. Improve usability, user journeys and product experiences across web, mobile and SaaS platforms.'},
        ],
      },
      {
        heading: "Staff Augmentation",
         sidebar: true,
        icon: 'ShieldCheck',
        items: [
           { label: 'CTO as a Service', href: ROUTES.CTO_AS_A_SERVICE, icon: 'assets/images/icon/cto.png', pageDesc: 'Empower your business with expert CTO advisory for smarter technology decisions.' ,metaDesc:''},
          { label: 'Hire Dedicated Developers', href: ROUTES.STAFF_AUGMENTATION, icon: 'assets/images/icon/coding.png', highlight: true, pageDesc: 'Extend your India team with skilled developers who integrate seamlessly' ,metaDesc:''},
        ],
      },
    ],
  },
  {
    label: 'Technology Services',
    href: "",
    megaColumns: 3,
    sidebarColumns: '2fr 2fr 2fr 1.5fr',
    drillGroups: true,
    pbExtra: 0,
    children: [
      
      {
        heading: "Software Development",
        icon: 'ShieldCheck',
        items: [
          { label: 'On Demand App Development', href: ROUTES.ON_DEMAND_APP_DEVELOPMENT, icon: 'assets/images/icon/app-development.png', highlight: true, pageDesc: 'Build scalable software tailored to your unique business needs.' ,metaDesc:'Build secure, scalable web and mobile applications tailored to your business. CruxBytes delivers custom software with modern engineering practices for enterprises across the globe.'},
          { label: 'SaaS / Product Development', href: ROUTES.SAAS_PLATFORM_DEVELOPMENT, icon: 'assets/images/icon/saas.png', highlight: true, pageDesc: 'Build scalable SaaS platforms designed for growth and flexibility.' ,metaDesc:'Build scalable SaaS platforms and digital products with CruxBytes. From product discovery and MVP development to architecture, launch and evolution.'},
          { label: 'eGovernance Dashboards', href: ROUTES.EGOVERNANCE, icon: 'assets/images/icon/egovernment.png', highlight: true, pageDesc: 'Build digital government platforms that enhance transparency and citizen services.' ,metaDesc:'Develop real-time eGovernance dashboards, programme monitoring systems and analytics platforms to improve government reporting and decision-making.'},
          { label: 'Application Modernization', href: ROUTES.APPLICATION_MODERNIZATION, icon: 'assets/images/icon/application-modernization.png', highlight: true, pageDesc: 'Modernize legacy applications for improved performance and scalability.' ,metaDesc:'Modernize legacy applications with CruxBytes. Improve performance, security and scalability through re-engineering, cloud migration and API enablement.'},
        ],
      },
      {
        heading: "Software Testing & QA",
        icon: 'ShieldCheck',
        items: [
          { label: 'Functional Testing', href: ROUTES.FUNCTIONAL_TESTING, icon: 'assets/images/icon/functional.png', highlight: true, pageDesc: 'Ensure quality through comprehensive manual and automated software testing.' ,metaDesc:'Ensure your software works as intended with functional testing covering features, workflows, integrations, usability, and business requirements.'},
          { label: 'Performance Testing', href: ROUTES.PERFORMANCE_TESTING, icon: 'assets/images/icon/performance.png', highlight: true, pageDesc: 'Identify vulnerabilities and strengthen applications through rigorous performance testings.' ,metaDesc:'Measure application speed, scalability, stability, and reliability with performance, load, stress, and scalability testing services.'},
          { label: 'API Testing', href: ROUTES.API_TESTING, icon: 'assets/images/icon/api.png', highlight: true, pageDesc: 'Validate API performance, reliability, and security for seamless integrations.' ,metaDesc:'Validate REST APIs, integrations, data flows, security, performance, and reliability with comprehensive API testing services from CruxBytes.'},
        ],
      },
      {
        heading: "Managed IT Services",
        icon: 'ShieldCheck',
        items: [
          { label: 'Software Maintenance & Support', href: ROUTES.AMC, icon: 'assets/images/icon/it-support.png', highlight: true, pageDesc: 'Keep applications secure, optimized, and running at peak performance.' ,metaDesc:'Keep your applications secure, reliable and up to date with software maintenance, technical support, enhancements and AMC services from CruxBytes.'},
          { label: 'DevOps & Infrastructure Management', href: ROUTES.DEVOPS, icon: 'assets/images/icon/devops.png', highlight: true, pageDesc: 'Accelerate software delivery with scalable DevOps strategies and automation.',metaDesc:'Improve application deployment, infrastructure reliability and operational efficiency with DevOps, CI/CD, monitoring and infrastructure management services.' },
          { label: 'Cloud Services & Management', href: ROUTES.CLOUD_SERVICES, icon: 'assets/images/icon/cloud-service.png', highlight: true, pageDesc: 'Seamlessly migrate applications and infrastructure to the cloud.',metaDesc:'Cloud migration, infrastructure management, optimization and support services to help businesses build secure, scalable and reliable cloud environments.' },
          { label: 'Domain, Email & Hosting Services', href: ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT, icon: 'assets/images/icon/domain.png', highlight: true, pageDesc: 'Simplify domain, DNS, email, and hosting management.' ,metaDesc:'Manage domains, business email, hosting, DNS, SSL and website infrastructure with reliable support from CruxBytes.'},
        ],
      },
       {
        heading: "Our Products",
        sidebar: true,
        icon: 'ShieldCheck',
        items: [
          { label: 'Inventory Management & ERP (IMERP)', href: ROUTES.HOME, icon: 'assets/images/icon/it-support.png', highlight: true, pageDesc: 'A windows based software for small sized retail & wholesale businesses.',metaDesc:'' },
          { label: 'Smart Business Manager (SBM)', href: ROUTES.HOME, icon: 'assets/images/icon/devops.png', highlight: true, pageDesc: 'Cloud based secured web applications for MSMEs and Corpartes to manage orders & invoices.',metaDesc:'' },          
        ],
      },
    ],
  },
  {
    label: 'AI/ML Development',
    href: "",
    megaColumns: 2,
    pbExtra: 0,
    children: [
      {
        heading: "",
        icon: 'ShieldCheck',
        items: [
          { label: 'AI Integration & Application Development', href: ROUTES.AI_INTEGRATION_APPLICATION_DEVELOPMENT, icon: 'assets/images/icon/machine-learning.png', highlight: true, pageDesc: 'Add intelligent features to existing and new software.',metaDesc:'Enhance web, mobile and enterprise applications with AI integration services. Add intelligent search, recommendations, document processing and AI-powered features.' },
      
          { label: 'Generative AI & Intelligent Assistants', href: ROUTES.GENAI_INTELLIGENT_ASSISTANTS, icon: 'assets/images/icon/gen-gi-llm-solutions.png', highlight: true, pageDesc: 'Make information easier to access, understand and use',metaDesc:'Build generative AI applications, business knowledge assistants and AI chatbots with CruxBytes. Make documents, enterprise information and customer support easier to access.' },
        ],
      },
      {
        heading: "",
        icon: 'ShieldCheck',
        items: [
          { label: 'AI Workflow Automation & Agents', href: ROUTES.AI_WORKFLOW_AUTOMATION_AGENTS, icon: 'assets/images/icon/conversational-ai-solutions.png', highlight: true, pageDesc: 'Connect AI capabilities with real business processes.',metaDesc:'Automate business workflows with AI-powered applications and agents. Connect systems, process information and streamline repetitive tasks with CruxBytes.' },
          { label: 'AI & Machine Learning Solutions', href: ROUTES.AI_MACHINE_LEARNING_SOLUTIONS, icon: 'assets/images/icon/ai-ml.png', highlight: true, pageDesc: 'Use data to identify patterns, forecast outcomes and support decisions.',metaDesc:'Build custom AI and machine learning solutions for forecasting, predictive analytics, anomaly detection and intelligent business applications with CruxBytes.' },
        ],
      },
      {
        heading: "How To AI ?",
        icon: 'ShieldCheck',
         
         sidebar: true,
        items: [
          { label: 'AI Use Cases & Business Applications', href: ROUTES.AI_USECASES_BUSINESS_APPLICATIION, icon: 'assets/images/icon/agentic-ai-solutions.png', highlight: true, pageDesc: 'Enhance your existing software, applications and digital platforms with AI wherever it creates practical value.' ,metaDesc:''},
        ],
      },
    ],
  },
  {
    label: 'Discover',
    href: "",
    megaColumns: 2,
    drillGroups: true,
    pbExtra: 0,
    children: [
       {
        heading: "Company",
        icon: 'ShieldCheck',
        items: [
           { label: 'About Us', href: ROUTES.OUR_LEGACY, icon: 'assets/images/icon/about.png', pageDesc: 'Explore our legacy, goals, leaders, and the values inspiring us.',metaDesc:'Learn about CruxBytes, an India-based IT services company delivering quality software engineering, AI, consulting and digital solutions for businesses across the globe.' },
      // { label: 'remove - Leadership', href: ROUTES.LEADERSHIP, icon: 'assets/images/icon/leadership.png', desc: 'Meet the leaders.' },
      // { label: 'Careers', href: '/career', icon: 'assets/images/icon/careers.png', desc: 'People, passion, and purpose.' },
      
      // { label: 'Portfolio', href: '/portfolio', icon: 'assets/images/icon/portfolio.png', desc: 'Proven technology expertise.' },
      { label: 'Partnerships', href: ROUTES.BE_A_PARTNER, icon: 'assets/images/icon/partnerships.png', pageDesc: 'Partner with us to build scalable solutions and lasting success.',metaDesc:'Partner with CruxBytes to collaborate on software development, digital transformation and technology solutions for business growth.' },
      { label: 'Careers At CruxBytes', href: ROUTES.CAREERS, icon: 'assets/images/icon/culture.png', pageDesc: 'Shaping Careers for people passionate to excel beyond limits.' ,metaDesc:'Explore careers at CruxBytes. Join a team focused on software engineering, emerging technologies, innovation and meaningful client projects.'},
      { label: 'Apply for Job', href: ROUTES.APPLY_FOR_JOB, icon: 'assets/images/icon/work.png', pageDesc: 'Come, join our team and feel the difference.',metaDesc:'Apply for career opportunities at CruxBytes. Share your skills, experience and interests to explore opportunities with our technology team.'},
        ],
      },
      {
        heading: "Portfolio",
        icon: 'ShieldCheck',
        items: [
           { label: 'Our Expertise', href: ROUTES.OUR_EXPERTISE, icon: 'assets/images/icon/expertise.png', pageDesc: 'Varied Tools, diverse industries, unique challenges, proven technology expertise.' ,metaDesc:'Explore CruxBytes expertise in software development, AI, technology consulting, UI/UX design, quality engineering, cloud and managed IT services.'},
      { label: 'Our Work', href: ROUTES.OUR_WORK, icon: 'assets/images/icon/work.png', pageDesc: 'Showcasing our work, cheering our success stories. Proudly ours!' ,metaDesc:'Explore CruxBytes projects and digital solutions across software engineering, government technology, dashboards, application modernization and more.'},
      { label: 'Our Clients', href: ROUTES.CLIENT_CORNER, icon: 'assets/images/icon/client.png', pageDesc: 'Nothing makes us happier than our clients happiness!' ,metaDesc:'Discover the organizations and businesses that work with CruxBytes for software development, technology consulting and digital solutions.'},
        ],
      },
     
       {
        heading: "Quick Look",
         sidebar: true,
        icon: 'ShieldCheck',
        items: [
           { label: 'Portfolio', href:ROUTES.OUR_WORK, icon: 'assets/images/icon/portfolio-menu.png', pageDesc: 'Explore our legacy, goals, leaders, and the values inspiring us.' ,metaDesc:''},
      
        ],
      },
      
    ],
  },
 
  // { label: 'Portfolio', href: '/portfolio' },
];


// ─── Stats ──────────────────────────────────────────────────────
// export const STATS = [
//   { value: '10+',   label: 'Years Experience',  icon: 'fa-calendar-check' },
//   { value: '150+',  label: 'Projects Delivered', icon: 'fa-check-double' },
//   { value: '80+',   label: 'Happy Clients',      icon: 'fa-face-smile' },
//   { value: '15+',   label: 'Team Members',       icon: 'fa-users' },
// ]
//--------------------

export const SALES_ENQUIRY = [
  { id: '1',   label: 'Request for Quote' },
  { id: '2',  label: 'Product / Service enquiry' },
  { id: '3',   label: 'Business Tie-up'},
  { id: '4',   label: 'Support related issues'},
  { id: '5',   label: 'General enquiry'},
]
// ─── Services ───────────────────────────────────────────────────
export const SERVICES = [
  {
    id: 'web-apps',
    icon: 'fa-globe',
    color: '#4f46e5',
    title: 'Web Application Development',
    short: 'Complex B2C/B2B web apps of any scale.',
    desc: 'We develop web applications of any complexity — from startup MVPs to large enterprise platforms, with the same quality and expertise as world-class IT companies.',
    features: ['Single Page Apps', 'Progressive Web Apps', 'REST/GraphQL APIs', 'Enterprise Portals'],
    href: '/software-services/web-application-development',
  },
  {
    id: 'mobile-apps',
    icon: 'fa-mobile-screen',
    color: '#06b6d4',
    title: 'Mobile App Development',
    short: 'Android, iOS, and cross-platform apps.',
    desc: 'Real-time mobile applications for Android, iOS, and Windows. We build apps that users love, with performance-first architecture.',
    features: ['Android (Native/Flutter)', 'iOS (Swift/Flutter)', 'Cross-Platform', 'App Store Deployment'],
    href: '/software-services/mobile-app',
  },
  {
    id: 'website-design',
    icon: 'fa-pen-nib',
    color: '#8b5cf6',
    title: 'Website & Logo Design',
    short: 'First impression is the last impression.',
    desc: 'We create business identities — logos, web designs, UX designs, brochures — everything the corporate world needs.',
    features: ['Responsive Websites', 'Logo Design', 'Brand Identity', 'UI/UX Design'],
    href: '/software-services/web-site-design',
  },
  {
    id: 'erp',
    icon: 'fa-warehouse',
    color: '#f59e0b',
    title: 'Inventory Management & ERP',
    short: 'Tailor-made ERP and inventory solutions.',
    desc: 'Custom ERP systems built for your business processes — from inventory and stock management to orders, billing, and reporting.',
    features: ['Inventory Control', 'Order Management', 'Billing & GST', 'Custom Reports'],
    href: '/software-services/service-offerings',
  },
  {
    id: 'qa',
    icon: 'fa-shield-halved',
    color: '#10b981',
    title: 'Quality Assurance & Testing',
    short: 'Reliable QA for smooth business continuity.',
    desc: 'Maintenance and QA is often the most ignored but most essential work. Our expert team ensures smooth operations, always.',
    features: ['Manual Testing', 'Automation Testing', 'Performance Testing', 'Maintenance'],
    href: '/software-services/qa-testing',
  },
  {
    id: 'digital',
    icon: 'fa-chart-line',
    color: '#ef4444',
    title: 'Digital Services',
    short: 'SEO, SEM, Hosting & Online Branding.',
    desc: 'From domain registration and reliable web hosting to SEO, SEM, and social media — we help you build and grow your digital presence.',
    features: ['SEO & SEM', 'Social Media', 'Web/Cloud Hosting', 'Domain Registration'],
    href: '/software-services/digital-services',
  },
]

// ─── Why Us ──────────────────────────────────────────────────────
export const WHY_US = [
  {
    icon: 'fa-bolt',
    title: 'End-to-End Delivery',
    desc: 'From ideation to deployment and beyond — we handle the entire technology lifecycle so you can focus on your business.',
  },
  {
    icon: 'fa-users',
    title: 'Startup to Enterprise',
    desc: 'Whether you are a bootstrapped startup or a large corporation, we deliver with the same quality standards.',
  },
  {
    icon: 'fa-shield-halved',
    title: 'Quality First',
    desc: 'Every project goes through rigorous QA. We do not ship unless it meets our standards — which are high.',
  },
  {
    icon: 'fa-headset',
    title: 'Dedicated Support',
    desc: 'Post-delivery support is never an afterthought. We provide reliable maintenance plans and responsive helpdesk.',
  },
  {
    icon: 'fa-indian-rupee-sign',
    title: 'Cost Effective',
    desc: 'Premium quality at competitive Indian pricing. Get world-class software without the world-class price tag.',
  },
  {
    icon: 'fa-handshake',
    title: 'Long-term Partnership',
    desc: 'Most of our clients have been with us for 5+ years. We grow when our clients grow. That is the CruxBytes promise.',
  },
]

// ─── Why Choose Our Services (Home page, above "What We Do") ────
// Content copied as-is from the DashCore reference, per instruction.
export const WHY_CHOOSE_SERVICES = [
  {
    // icon: 'fa-award',
    icon: 'assets/images/icon/software-consulting.png',
    title: 'Software Consulting',
    desc: 'Navigate complex technology decisions with confidence through our strategic IT consulting services. Identify the right technologies, scalable roadmaps & implement cloud, AI solutions that align with future growth.',
    statValue: '10+ years',
    statLabel: 'Average Experience',
    link: ROUTES.SOFTWARE_CONSULTING,
  },
  {
    icon: 'assets/images/icon/ui-ux.png',
    title: 'UI/UX Design',
    desc: 'Create memorable digital experiences with intuitive, user-centric designs. Our UI/UX specialists craft visually engaging, accessible, and responsive interfaces that simplify user journeys, improve engagement, increase conversions, and strengthen your brands digital presence.',
    statValue: '99.9%',
    statLabel: 'Uptime Guaranteed',
      link: ROUTES.UI_UX_DESIGN,
  },
  {
   icon: 'assets/images/icon/app-development.png',
    title: 'On Demand App Development',
    desc: 'Transform your ideas into scalable, high-performance software tailored to your business. From cloud-native applications and enterprise platforms to modernizing legacy systems, we build secure, reliable solutions designed to support long-term growth and innovation.',
    statValue: '10x',
    statLabel: 'Scalability Factor',
      link: ROUTES.ON_DEMAND_APP_DEVELOPMENT,
  },
  {
    icon: 'assets/images/icon/ai-ml.png',
    title: 'AI & ML Solutions',
    desc: 'Unlock the power of Artificial Intelligence to automate processes, uncover valuable insights, and deliver smarter customer experiences. From intelligent assistants and predictive analytics to generative AI and conversational softwares, we build AI applications that create measurable business value.',
    statValue: '24/7',
    statLabel: 'Support Available',
      link: ROUTES.AI_USECASES_BUSINESS_APPLICATIION,
  },
  // ── Row 2 (duplicated placeholders, matching reference layout) ──
  {
    icon: 'assets/images/icon/functional.png',
    title: 'Software Testing & Quality Assurance',
    desc: 'Deliver software with confidence through comprehensive testing and quality assurance. Our experts ensure your applications are secure, reliable, and high-performing by identifying defects early, validating functionality, and maintaining compliance with industry best practices.',
    statValue: '10+ years',
    statLabel: 'Average Experience',
      link: ROUTES.FUNCTIONAL_TESTING,
  },
  {
     icon: 'assets/images/icon/it-support.png',
    title: 'Managed IT Services',
    desc: 'Keep your business running smoothly with proactive application maintenance and ongoing technical support. We continuously monitor performance, resolve issues quickly, implement updates, and optimize your applications to ensure reliability, security, and uninterrupted operations.',
    statValue: '99.9%',
    statLabel: 'Uptime Guaranteed',
      link: ROUTES.AMC,
  },
  {
    icon: 'assets/images/icon/coding.png',
    title: 'Staff Augmentation',
    desc: 'Scale your development capabilities with experienced technology professionals who integrate seamlessly into your team. Whether you need specialized expertise or additional resources, our flexible staff augmentation services help accelerate project delivery while maintaining the highest quality standards.',
    statValue: '10x',
    statLabel: 'Scalability Factor',
      link: ROUTES.STAFF_AUGMENTATION,
  },
]

// ─── Working Process (Home page, above SparkParticipation) ──────
export const PROCESS_STEPS = [
  { number: '01', title: 'Business Discovery', desc: 'Understanding your business objectives and identifying high-impact AI opportunities.' },
  { number: '02', title: 'Tech Strategy',    desc: 'Defining the right roadmap, technology stack, and implementation approach.' },
  { number: '03', title: 'Intelligent Design', desc: 'Designing scalable architecture, workflows, and seamless user experiences (UX/UI).' },
  { number: '04', title: 'Model Engineering',      desc: 'Building and fine-tuning AI models for optimal performance.' },
  { number: '05', title: 'Quality Assurance',     desc: 'Validating accuracy, security, and reliability through comprehensive testing.' },
  { number: '06', title: 'Deployment',     desc: 'Launching solutions with seamless integration into your existing ecosystem or on cloud.' },
  { number: '07', title: 'Optimization & Support',     desc: 'Continuously monitoring, improving, and scaling the developed solution for long-term success by providing 24x7 proactive technical support.' },

]

// ─── Tech Stacks ────────────────────────────────────────────────
export const TECH_STACKS = [
  { category: 'Frontend',     icon: 'fa-desktop',  techs: ['React', 'Angular', 'Vue', 'Bootstrap', 'HTML5', 'CSS3'] },
  { category: 'Backend',      icon: 'fa-server',   techs: ['Node.js', 'PHP', '.NET', 'Java', 'Python', 'Laravel'] },
  { category: 'Mobile',       icon: 'fa-mobile-screen', techs: ['Flutter', 'Android', 'iOS', 'Ionic', 'React Native'] },
  { category: 'Database',     icon: 'fa-database', techs: ['MySQL', 'PostgreSQL', 'MongoDB', 'MSSQL', 'Redis'] },
  { category: 'Cloud',        icon: 'fa-cloud',    techs: ['AWS', 'Azure', 'GCP', 'cPanel', 'Docker', 'Linux'] },
  { category: 'Tools & QA',   icon: 'fa-gears',    techs: ['Git', 'JIRA', 'Selenium', 'Postman', 'Figma', 'VS Code'] },
]

// ─── Industries ──────────────────────────────────────────────────
export const INDUSTRIES = [
  { icon: 'fa-building-columns', label: 'Government & PSUs', color: '#4f46e5' },
  { icon: 'fa-bolt',             label: 'Power & Energy',    color: '#f59e0b' },
  { icon: 'fa-heart-pulse',      label: 'Healthcare',        color: '#ef4444' },
  { icon: 'fa-graduation-cap',   label: 'Education',         color: '#06b6d4' },
  { icon: 'fa-cart-shopping',    label: 'Retail & E-Commerce', color: '#10b981' },
  { icon: 'fa-industry',         label: 'Manufacturing',     color: '#8b5cf6' },
  { icon: 'fa-building',         label: 'Real Estate',       color: '#f97316' },
  { icon: 'fa-plane',            label: 'Travel & Logistics', color: '#84cc16' },
]

// ─── Case Studies (Portfolio) ───────────────────────────────────
export const CASE_STUDIES = [
  {
    id: 'praapti',
    tag: 'Power Sector',
    tagColor: '#f59e0b',
    title: 'PRAAPTI — Payment Ratification & Analysis in Power Procurement',
    desc: 'A flagship initiative by Ministry of Power, Government of India. Built and maintained the PRAAPTI portal for power sector transparency.',
    metrics: [{ value: '₹Cr+', label: 'Transactions' }, { value: 'GoI', label: 'Client' }, { value: 'Live', label: 'Status' }],
    industry: 'Government',
  },
  {
    id: 'merit',
    tag: 'Energy',
    tagColor: '#10b981',
    title: 'MERIT — Market Monitoring for POSOCO',
    desc: 'Real-time energy market monitoring and analysis platform developed for Power System Operation Corporation (POSOCO).',
    metrics: [{ value: 'RT', label: 'Real-time' }, { value: 'POSOCO', label: 'Client' }, { value: 'Live', label: 'Status' }],
    industry: 'Power & Energy',
  },
  {
    id: 'delp',
    tag: 'LED Programme',
    tagColor: '#4f46e5',
    title: 'DELP — Domestic Efficient Lighting Programme Dashboard',
    desc: 'National LED programme dashboard for tracking LED bulb distribution across India, built for EESL and Ministry of Power.',
    metrics: [{ value: 'National', label: 'Scale' }, { value: 'EESL', label: 'Client' }, { value: 'Live', label: 'Status' }],
    industry: 'Government',
  },
]

// ─── Testimonials ────────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    id: '1',
    name: 'Project Lead',
    role: 'Ministry of Power, Govt. of India',
    quote: 'CruxBytes delivered the PRAAPTI platform on time with exceptional quality. Their team understood our complex requirements and executed flawlessly.',
    rating: 5,
    avatar: 'MP',
  },
  {
    id: '2',
    name: 'IT Head',
    role: 'POSOCO — Power System Operation Corp.',
    quote: 'The MERIT system has transformed how we monitor the energy market. CruxBytes team is responsive and technically very strong.',
    rating: 5,
    avatar: 'PS',
  },
  {
    id: '3',
    name: 'Business Owner',
    role: 'Retail Chain, Mumbai',
    quote: 'Their ERP system completely streamlined our inventory and billing. The support team is always available. Highly recommend CruxBytes.',
    rating: 5,
    avatar: 'RC',
  },
  {
    id: '4',
    name: 'Startup Founder',
    role: 'HealthTech Startup, Pune',
    quote: 'As a startup, we needed a partner who understood both technology and business. CruxBytes fitted perfectly — affordable, capable, reliable.',
    rating: 5,
    avatar: 'HT',
  },
]

// ─── FAQ ─────────────────────────────────────────────────────────
export const FAQS = [
  {
    q: 'What types of businesses do you work with?',
    a: 'We work with businesses of all sizes — from early-stage startups to large corporations and government departments. Our experience spans multiple industries including power, healthcare, retail, education, and more.',
  },
  {
    q: 'Do you offer post-delivery support and maintenance?',
    a: 'Yes, absolutely. All our projects include a warranty period post-delivery, and we offer structured Annual Maintenance Contracts (AMCs) for long-term support. Most of our clients continue with us for 5+ years.',
  },
  {
    q: 'How does the project engagement work?',
    a: 'It starts with a free consultation to understand your requirements. We then share a detailed proposal with scope, timeline, and cost. Once agreed, we follow an agile delivery model with regular demos and checkpoints.',
  },
  {
    q: 'Can you work with our existing technology stack?',
    a: 'Yes. We have expertise across a wide range of technologies and can seamlessly integrate with or extend your existing systems. We are technology-agnostic and always recommend the best fit for your needs.',
  },
  {
    q: 'How do you handle project timelines and cost overruns?',
    a: 'We follow a strict project management discipline with weekly status reports. We commit to timelines and costs in writing upfront. Any changes in scope are handled via a formal change request process.',
  },
  {
    q: 'Do you sign NDAs and protect our intellectual property?',
    a: 'Yes. We sign NDAs before any detailed discussion. All IP created during the project belongs entirely to you — we do not retain any rights to your code, designs, or data.',
  },
]

// ─── Footer Links ────────────────────────────────────────────────
export const FOOTER_LINKS = {
   Consulting: [
    { label: 'Software Consulting', href: ROUTES.SOFTWARE_CONSULTING },
    // { label: 'Cloud Consulting', href: ROUTES.CLOUD_CONSULTING },
    // { label: 'Legacy System Modernization', href: ROUTES.LEGACY_SYSTEM_MODERNIZATION },    
    { label: 'AI Strategy Consulting', href: ROUTES.AI_STRATEGY_CONSULTING },
    { label: 'Security & Compliance Advisory', href: ROUTES.SECURITY_COMPLIANCE_ADVISORY },
   
  ],
   'Design & Product': [
    { label: 'UI/UX Design', href: ROUTES.UI_UX_DESIGN },
    { label: 'Product Experience Design', href:ROUTES.PRODUCT_EXPERIENCE_DESIGN  },
  ],

  'Software Development': [
    { label: 'On Demand App Development', href: ROUTES.ON_DEMAND_APP_DEVELOPMENT },
    { label: 'SaaS / Product Development', href: ROUTES.SAAS_PLATFORM_DEVELOPMENT },
    { label: 'eGovernance Dashboards', href:ROUTES.EGOVERNANCE },
    { label: 'Application Modernization', href: ROUTES.APPLICATION_MODERNIZATION },
  ],

  'Software Testing & QA': [
    { label: 'Functional Testing', href: ROUTES.FUNCTIONAL_TESTING},
    { label: 'Performance Testing', href: ROUTES.PERFORMANCE_TESTING},
    { label: 'API Testing', href: ROUTES.API_TESTING },
  ],

  'Managed IT Services': [
    { label: 'Software Maintenance & Support', href: ROUTES.AMC },
    { label: 'DevOps & Infrastructure Management', href: ROUTES.DEVOPS },
    { label: 'Cloud Services & Management',href: ROUTES.CLOUD_SERVICES },
    { label: 'Domain, Email & Hosting Services', href:ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT},
    ],
   'Staff Augmentation': [
    { label: 'CTO as a Service', href: ROUTES.CTO_AS_A_SERVICE },
    { label: 'Hire Dedicated Developers', href:ROUTES.STAFF_AUGMENTATION },   
      
  ],

  'AI/ML Development':[
    { label: 'Data & ML Engineering', href: ROUTES.AI_INTEGRATION_APPLICATION_DEVELOPMENT },
    { label: 'GenAI & LLM Solutions', href: ROUTES.GENAI_INTELLIGENT_ASSISTANTS },
    { label: 'Conversational AI Solutions', href: ROUTES.AI_WORKFLOW_AUTOMATION_AGENTS },
    { label: 'Agentic AI Solutions', href: ROUTES.AI_USECASES_BUSINESS_APPLICATIION },
  ],
  Portfolio: [
   { label: 'Our Expertise',  href: ROUTES.OUR_EXPERTISE },
   { label: 'Our Work',  href: ROUTES.OUR_WORK },
    { label: 'Our Clients', href: ROUTES.CLIENT_CORNER },          
  ],
   Discover: [    
     { label: 'About Us',       href: ROUTES.OUR_LEGACY },
    { label: 'Partnerships',     href: ROUTES.BE_A_PARTNER },
   { label: 'Careers At CruxBytes',       href: ROUTES.CAREERS },   
   { label: 'Apply for Job', href: ROUTES.APPLY_FOR_JOB },    
  ],
Legal: [
    { label: 'Terms of Use',   href: ROUTES.TERMS_OF_USE },
    { label: 'Privacy Policy',     href: ROUTES.PRIVACY_POLICY},
    { label: 'Disclaimer',         href: ROUTES.DISCLAIMER },
    { label: 'Sitemap',            href: ROUTES.SITEMAP },
  ]
}

// ─── Client Logos ────────────────────────────────────────────────
export const CLIENTS = [
  { name: 'Ministry of Power, GoI',   abbr: 'MoP'  },
  { name: 'EESL',                      abbr: 'EESL' },
  { name: 'POSOCO',                    abbr: 'PSOC' },
  { name: 'PricewaterhouseCoopers',    abbr: 'PwC'  },
  { name: 'NTPC',                      abbr: 'NTPC' },
  { name: 'Local Client A',            abbr: 'CLA'  },
]


// ─── Services Content (for individual service pages) ─────────────────────────
// URL mapping: old .php → new React routes (no /software-services/ prefix needed)
export const SERVICES_NAV = [
  {
    label: 'Service Offerings',
    href: '/software-services/service-offerings',
    icon: 'fa-layer-group',
  },
  {
    label: 'Application Development',
    href: '/software-services/enterprise-application-development',
    icon: 'fa-code',
    children: [
      { label: 'Web Apps',               href: '/software-services/web-application-development',  icon: 'fa-globe' },
      { label: 'Mobile Apps',            href: '/software-services/mobile-app',                   icon: 'fa-mobile-screen' },
      { label: 'Windows Apps',           href: '/software-services/windows-application-development', icon: 'fa-window-maximize' },
      { label: 'Content Management System', href: '/software-services/content-management-system', icon: 'fa-layer-group' },
    ],
  },
  { label: 'Website Design',        href: '/software-services/web-site-design',    icon: 'fa-pen-nib' },
  { label: 'UI/UX Design',          href: '/software-services/ui-ux-design',       icon: 'fa-wand-magic-sparkles' },
  { label: 'Quality Assurance & Testing', href: '/software-services/qa-testing',   icon: 'fa-shield-halved' },
  { label: 'Digital Services',      href: '/software-services/digital-services',   icon: 'fa-chart-line' },
]


// ── Contact page FAQ ──────────────────────────────────────────────────
export const CONTACT_FAQ = [
  {
    q: '01. Why should we choose CruxBytes as our technology partner?',
    a: 'CruxBytes combines technology expertise with a strong understanding of business needs. We focus on practical, scalable solutions, transparent collaboration, and long-term partnerships—helping organizations turn technology investments into measurable business value.',
  },
  {
    q: '02. What types of businesses does CruxBytes work with?',
    a: `We work with startups, SMEs, and established enterprises across industries. Our solutions are tailored to each organization's technology needs, business processes, growth objectives, and operational challenges.`,
  },
  {
    q: '03. Can CruxBytes develop custom software for our business?',
    a: 'Yes. We specialize in custom software development (web apps and mobile apps) and build scalable applications around your specific workflows, requirements, and business goals. From initial concept to development and ongoing support, we can support the complete product lifecycle.',
  },
  {
    q: '04. Where does CruxBytes operate, and can you work with global clients?',
    a: 'CruxBytes is based in Mumbai, India and works with clients across India and international markets, including businesses in the USA, Australia, Dubai, and other global locations. Our flexible approach enables us to collaborate effectively with teams across different time zones.',
  },
  {
    q: '05. Does CruxBytes provide AI and Machine Learning solutions?',
    a: 'Yes. We help businesses identify practical AI opportunities and develop solutions using AI, machine learning, Generative AI, LLMs, conversational AI, and autonomous AI agents to improve efficiency, automate workflows, and enhance customer experiences.',
  },
  {
    q: '06. Can you help us modernize our legacy applications?',
    a: 'Absolutely. We assess existing applications, identify modernization opportunities, and help transform legacy systems into more secure, scalable, maintainable, and cloud-ready platforms while minimizing disruption to business operations.',
  },
  {
    q: '07. Does CruxBytes provide technology consulting and strategic guidance?',
    a: 'Yes. Our technology consulting services help organizations make informed decisions around software architecture, cloud adoption, AI strategy, digital transformation, security, technology roadmaps, and product development.',
  },
  {
    q: '08. Can we hire dedicated developers or extend our existing technology team?',
    a: 'Yes. Our staff augmentation and dedicated developer services allow you to add experienced technology professionals to your team based on your skills, project requirements, timelines, and budget.',
  },
  {
    q: '09. Can CruxBytes work with our existing technology team?',
    a: 'Yes. We can work as an extension of your internal technology team or take complete ownership of specific projects or technology functions. Our engagement model can be adapted to your existing processes, tools, and workflows.',
  },
  {
    q: '10. Do you provide ongoing application maintenance and support?',
    a: 'Yes. We provide ongoing application maintenance and technical support to help keep your software secure, stable, optimized, and aligned with changing business requirements. Our support can include monitoring, troubleshooting, updates, enhancements, and performance optimization.',
  },

  {
    q: '11. What technology services does CruxBytes offer?',
    a: 'CruxBytes provides end-to-end technology services including software development, technology consulting, UI/UX design, AI/ML solutions, SaaS development, cloud services, legacy modernization, software testing, DevOps, application support, and dedicated development teams.',
  },
  {
    q: '12. How does CruxBytes approach a new software development project?',
    a: 'We begin by understanding your business objectives, users, existing technology environment, and project requirements. We then define the appropriate solution, roadmap, architecture, and delivery approach before moving into design, development, testing, and deployment.',
  },
  {
    q: '13. How do you ensure software quality and security?',
    a: 'Quality and security are considered throughout the development lifecycle. Our QA practices include functional, performance, API, automation, and security testing to help deliver reliable, secure, and production-ready software.',
  },
]